import { useCurrentUser } from '@monorepo/shared/hooks/useCurrentUser';

export function useIsSuperAdmin() {
  const { currentUser } = useCurrentUser();
  // eslint-disable-next-line camelcase
  return Boolean(currentUser?.is_super_admin);
}
